import { memo } from 'react';

import { DefaultNoWorkspaceContentState } from '~/components/AllContent/DefaultNoWorkspaceContentState';
import { useCanShowBoardsInAllContent } from '~/components/AllContent/hooks/useCanShowBoardsInAllContent';
import { AllContentGalleryBoard } from '~/components/PrivateGallery/AllContentGalleryBoard';
import { PrivateGalleryAsset } from '~/components/PrivateGallery/PrivateGalleryAsset';
import { PrivateGalleryFile } from '~/components/PrivateGallery/PrivateGalleryFile';
import { PrivateGalleryView, type PrivateGalleryViewProps } from '~/components/PrivateGallery/PrivateGalleryView';

export type AllContentGalleryViewProps = {
  scrollElementRef: PrivateGalleryViewProps['scrollElementRef'];
};

/**
 * @deprecated Use SearchPageGalleryView instead
 */
export const AllContentGalleryView = memo(({ scrollElementRef }: AllContentGalleryViewProps) => {
  const { canShowBoards } = useCanShowBoardsInAllContent();

  return (
    <PrivateGalleryView
      EmptyState={DefaultNoWorkspaceContentState}
      scrollElementRef={scrollElementRef}
      renderBoard={({ box, data, index }) => (
        <AllContentGalleryBoard box={box} data={data} index={index} key={data.id} />
      )}
      renderAsset={({ box, data, index }) => <PrivateGalleryAsset box={box} data={data} index={index} key={data.id} />}
      renderFile={({ box, data, index }) => <PrivateGalleryFile box={box} data={data} index={index} key={data.id} />}
      showBoards={canShowBoards}
    />
  );
});

AllContentGalleryView.displayName = 'AllContentGalleryView';
